module.exports = __webpack_public_path__ + "img/edge_activites_pieds_nus.4b1a88ac.svg";